import instance from "@/http";

let ossConfigOption = {
    'askbot-open': {
        region: "oss-cn-zhangjiakou",
        bucket: "guoranopen-zjk",
    },
    "lishi-open": {
        region: "oss-ap-southeast-1",
        bucket: "askbotopen-ls",
    },
    "meinian-open": {
        region: "oss-cn-zhangjiakou",
        bucket: "guoranopen-zjk",
    },
    'askbot-wisdom': {
        region: "oss-cn-zhangjiakou",
        bucket: "guoranwisdom",
    },
    "lishi-wisdom": {
        region: "oss-ap-southeast-1",
        bucket: "askbotwisdom-ls",
    },
    "meinian-wisdom": {
        region: "oss-ap-southeast-1",
        bucket: "askbotwisdom-ls",
    }
};

function generateOssConfig(bucketType) {
    return ossConfigOption[process.env.VUE_APP_SOURCE + '-' + bucketType]
}

async function getSTSToken() {
    const response = await instance.get('/api/oss-sts-token/get');
    const info = response.data.data || response.data;
    const stsToken = info.stsToken || info.securityToken;
    if (!info.accessKeyId || !info.accessKeySecret || !stsToken) {
        throw new Error('获取 OSS STS 凭证失败');
    }
    return {
        accessKeyId: info.accessKeyId,
        accessKeySecret: info.accessKeySecret,
        stsToken,
    };
}

async function generateStsOssConfig(ossConfig) {
    return {
        ...ossConfig,
        authorizationV4: true,
        ...await getSTSToken(),
        refreshSTSToken: getSTSToken,
        refreshSTSTokenInterval: 1800000,
    };
}

export { generateOssConfig, generateStsOssConfig }


